import React from 'react';
import { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '/@/app/AppContext';
import { Container, Box, Button, Collapse, Alert } from '@mui/material';
import { route } from '/@/app/routes';

export const ExpirationNotice = () => {
    const {bootstrapData} = useContext(AppContext);
    const panel = bootstrapData.panel;

    if (panel.is_editable) {
        return <></>;
    }

    return (
        <Alert
            severity="warning"
            sx={{
                ".MuiAlert-message": { flexGrow: "1" },
                textAlign: "left",
                mb: 1,
            }}
        >
            {panel.is_imported ?
                <Box sx={{ mb: 1 }}>
                    <strong>Внимание!</strong> Вы используете неизменяемую панель лабораторных данных.
                    {' '}
                    <Button variant="text" component={Link} to={route("/panels/")}>
                        Переключите панель.
                    </Button>
                </Box>
            :
                <Box sx={{ mb: 1 }}>
                    <strong>Внимание!</strong> Ваши анализы сделаны дольше 180 дней назад.
                    {' '}
                    <Button variant="text" component={Link} to={route("/panels/")} sx={{ mb: -2 }}>
                        Создайте новую панель.
                    </Button>
                </Box>
            }
        </Alert>
    );
}
